const imageZoom = () => {
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('img.zoomable').forEach(function (img) {
            img.style.cursor = 'zoom-in';

            img.addEventListener('click', function () {
                const overlay = document.createElement('div');
                overlay.classList.add('zoom-overlay');

                const clone = document.createElement('img');
                clone.src = img.src;

                overlay.appendChild(clone);
                document.body.appendChild(overlay);

                overlay.addEventListener('click', function () {
                    overlay.remove();
                });
            });
        });
    });
};

export default imageZoom;
